import { render, staticRenderFns } from "./ActivityLevel.vue?vue&type=template&id=4f525172"
import script from "./ActivityLevel.vue?vue&type=script&lang=js"
export * from "./ActivityLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports